import React from "react";
import RefundListHeader from "./RefundListHeader";
import RefundListTable from "./RefundListTable";

const RefundVoucherList = () => {
  return (
    <>
      <div className="content-header">
        <div className="container-fluid px-2">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active">Refund Voucher List</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content" style={{ paddingBottom: "1.5rem" }}>
        <div className="container-fluid px-4">
          <RefundListHeader />
          <RefundListTable />
        </div>
      </section>
    </>
  );
};

export default RefundVoucherList;